;(function () {

"use strict";

var copy = require('copy-to-clipboard');
var MetafieldsFormView = require('../views/metafields-form');

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init upsert view');

    window.Buttons = {
      primary: {
        label: "Save Metafields",
        message: 'metafields_form_submit',
        loading: true,
        callback: function (message, data) {
          window.App.Events.trigger('submit');
        }
      }
    };

    if (window.data.isRedirect) {
      $('.back-btn').on('click', function (e) {
        // alert(window.parent.history);
        // alert('here');
        // window.parent.history.back();
        $("#object-deep-link").trigger('click');
        return false;
      });
    }

    new MetafieldsFormView({ el: this.$el.find('form.metafields') });

    console.log(copy);

  },
  deleteMetafield: function (e) {
    console.log('deleting metafield');
    var self = this;

    var $this = $(e.currentTarget);
    var id = $this.closest('.non-tracked-metafield, .tracked-metafield').data('metafield-id');

    ShopifyApp.Modal.confirm({
      title: 'Delete Metafield',
      message: "Warning: Metafields Manager is not responsible for any damage to your site as a result of this action. Are you sure you want to delete this metafield? It could effect your storefront or other Shopify Apps.",
      okButton: "Yes, delete this metafield",
      cancelButton: "No, keep this metafield",
      style: "danger"
    }, function (result) {

      if (result === true) {
        console.log(window.data.type);
        console.log(id);
        $.ajax({
          url: "/detail/"+window.data.type+'/'+id,
          type: 'DELETE',
          success: function (response) {
            console.log(response);
            console.log('deleted metafield');
            window.location.reload();
          }
        });
      }
    });

    return false;
  },
  hideAll: function (e) {
    console.log('hiding all');
    this.$el.find('.metafields .accordian-toggle.visible').each(function () {
      $(this).find('span').trigger('click');
    })
    e.preventDefault();
  },
  events: {
    'click code + .copy': function (e) {
      var $this = $(e.currentTarget);
      var text = $this.prev().text();

      copy(text, {
        debug: true,
        message: 'Press ⌘-C to copy'
      });

      ShopifyApp.flashNotice('The code has been copied to your clipboard');
    },
    'click .non-tracked-metafield .delete-metafield': 'deleteMetafield',
    'click .tracked-metafield .delete-metafield': 'deleteMetafield',
    'click #toggle-all-metafields': 'hideAll'
  }
});

module.exports = PageView;

}());